<template>
<div ref="element" :style="{ width, height }">
    <slot v-if="ready"></slot>
</div>
</template>

<script>
export default {
    props: {
        width: { type: String, default: "500px" },
        height: { type: String, default: "400px" },

        centerPosition: { type: Object, default: null },
        centerAddress: { type: String, default: null },

        level: { type: Number, default: 3 },
    },
    data() {
        return {
            ready: false,

            map: null,
            geocoder : null,

            center: Object.assign({ lat: 33.450701, lng: 126.570667 }, this.centerPosition)
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init() {
            //////////////////////////////////////////////////////////////////////////////////
            // 카카오맵 인스턴스 초기화
            //////////////////////////////////////////////////////////////////////////////////
            var element = this.$refs.element; //지도를 담을 영역의 DOM 레퍼런스
            var options = { //지도를 생성할 때 필요한 기본 옵션
                center: new kakao.maps.LatLng(this.center.lat, this.center.lng), //지도의 중심좌표.
                level: this.level //지도의 레벨(확대, 축소 정도)
            };

            this.map = new kakao.maps.Map(element, options); //지도 생성 및 객체 리턴
            this.geocoder = new kakao.maps.services.Geocoder();

            if(this.centerAddress){
                this.searchAddress(this.centerAddress).then((position) => {
                    this.center = position;
                });
            }

            this.$nextTick(() => {
                this.ready = true;
            });

            // 카카오맵 클릭 이벤트 등록
            this.addClickEventListener(({ position, address }) => {
                this.$emit("click", { position, address });
            });
        },

        addClickEventListener(callback){
            kakao.maps.event.addListener(this.map, 'click', (mouseEvent) => {
                var position = {
                    lat: mouseEvent.latLng.Ma,
                    lng: mouseEvent.latLng.La
                };

                var address = null;

                this.geocoder.coord2Address(mouseEvent.latLng.La, mouseEvent.latLng.Ma, (result, status) => {
                    if (status === kakao.maps.services.Status.OK) {
                        address = result[0].address.address_name;
                    }
                    callback({ position, address });
                });
            });
        },

        searchAddress(address){
            return new Promise((resolve) => {
                if(this.geocoder){
                    this.geocoder.addressSearch(address, (result, status) => {
                        if (status === kakao.maps.services.Status.OK) {
                            resolve({
                                lat: result[0].y,
                                lng: result[0].x
                            });
                        }
                        else resolve(null);
                    });
                }
                else resolve(null);
            });
        }
    },
    watch: {
        centerPosition(value){
            this.center = value;
        },
        centerAddress(value){
            if(value) this.searchAddress(value).then((position) => { this.center = position; });
        },
        center(value){
            console.log({ center: value });
            var position = Object.assign({ lat: 33.450701, lng: 126.570667 }, value)
            if(this.map) this.map.setCenter(new kakao.maps.LatLng(position.lat, position.lng));
        }
    }
}
</script>

<style lang="css" scoped>
</style>
